import wixLocation from 'wix-location';
import wixData from 'wix-data';
import wixWindow from 'wix-window';

$w.onReady(function () {
    let lang = wixWindow.multilingual.currentLanguage;
    $w('#repeater1').onItemReady(($item, itemData) => {
        // Hebrew
        if (lang === 'he') {
            $item('#text43').text = itemData.titleHe;
            $item('#text42').html = itemData.textHe;
        }

        // English
        else {
            $item('#text43').html = '<span style="text-align: left; font-size: 40px; font-family: almoni-dl-aaa-700;">' + itemData.title + '</span>';
            $item('#text42').html = itemData.text;
        }
    });
});